import axios from 'axios'
import { batchHeaders } from '@/util/zonesBatch'

const state = {
  polygons: [],
}

const getters = {
  getPolygons (state) {
    return state.polygons
  },
}

const mutations = {
  setPolygons (state, newVal) {
    state.polygons = newVal
  },
}

const actions = {
  fetchPolygonsList ({ commit, rootGetters }, meta) {
    return axios
      .get(
        `${rootGetters['api/polygonsList']}?limit=${meta.limit}&offset=${meta.offset}&page=${meta.page}`,
      )
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
  // ошибку не глотаем: страница зон показывает её и оставляет зону в очереди на сохранение;
  // batchId - операция одного «Сохранить» (один снимок филиала на бэке)
  createPolygons ({ rootGetters }, { data, batchId }) {
    return axios
      .post(rootGetters['api/polygonsCreate'], data, batchHeaders(batchId))
      .then((res) => res.data.data)
  },
  // ошибку не глотаем: страница зон оставляет зону в очереди на удаление и показывает её
  deletePolygons ({ rootGetters }, { id, batchId }) {
    return axios.delete(rootGetters['api/polygonsDelete'](id), batchHeaders(batchId))
  },
  getPolygonsFromApi ({ commit, rootGetters }, payload = {}) {
    return axios
      .get(`${rootGetters['api/polygonsList']}`, {
        params: payload,
      })
      .then(res => {
        commit('setPolygons', res.data.items)
        return res.data.items
      })
  },
  fetchByFilial ({ rootGetters }, filialId = null) {
    const params = filialId && filialId !== 'all' ? { filialId } : {}
    return axios
      .get(rootGetters['api/deliveryZones'], { params })
      .then((res) => ({
        items: res.data.items || [],
        defaultTiers: (res.data.meta && res.data.meta.defaultTiers) || {},
      }))
  },
  // Список филиалов карты — отдельным запросом (грузим один раз при открытии страницы)
  fetchFilials ({ rootGetters }) {
    return axios
      .get(rootGetters['api/polygonsFilials'])
      .then((res) => res.data.items || [])
  },
  updatePolygon ({ rootGetters }, { id, data, batchId }) {
    return axios
      .put(rootGetters['api/polygonsUpdate'](id), data, batchHeaders(batchId))
      .then((res) => res.data.data)
  },
  saveFilialTiers ({ rootGetters }, { filialId, tiers, batchId }) {
    return axios.patch(rootGetters['api/polygonsFilialTiers'](filialId), tiers, batchHeaders(batchId))
  },
  saveNetworkTiers ({ rootGetters }, { tiers, batchId }) {
    return axios.patch(rootGetters['api/polygonsNetworkTiers'], tiers, batchHeaders(batchId))
  },
  // Импорт KML: проверка файла → план с токеном сессии (30 минут)
  importPreview ({ rootGetters }, { file, format, scope, filialIds }) {
    const form = new FormData()
    form.append('file', file)
    form.append('format', format)
    form.append('scope', scope)
    ;(filialIds || []).forEach((id) => form.append('filialIds[]', id))
    return axios
      .post(rootGetters['api/polygonsImportPreview'], form)
      .then((res) => res.data.data)
  },
  // окончательный план по филиалам после решений по конфликтам (ничего не меняет)
  importResolve ({ rootGetters }, { token, resolutions }) {
    return axios
      .post(rootGetters['api/polygonsImportResolve'], { token, resolutions })
      .then((res) => res.data.data)
  },
  importApply ({ rootGetters }, { token, resolutions, deleteIds }) {
    return axios
      .post(rootGetters['api/polygonsImportApply'], { token, resolutions, deleteIds })
      .then((res) => res.data.data)
  },
  // KML-файл зон (Blob); имя файла собирает вызывающий: Content-Disposition не виден кросс-доменно
  exportKml ({ rootGetters }, { format, scope, filialIds }) {
    return axios
      .get(rootGetters['api/polygonsExport'], {
        params: { format, scope, filialIds: scope === 'filials' ? filialIds : undefined },
        responseType: 'blob',
      })
      .then((res) => res.data)
  },
  // версии зон: снимок филиала для предпросмотра, план отката и откат (филиал или партия импорта)
  fetchSnapshot ({ rootGetters }, id) {
    return axios.get(rootGetters['api/polygonsSnapshot'](id)).then((res) => res.data.data)
  },
  fetchRestorePlan ({ rootGetters }, id) {
    return axios.get(rootGetters['api/polygonsRestorePlan'](id)).then((res) => res.data.data)
  },
  restoreSnapshot ({ rootGetters }, { id, fingerprint }) {
    return axios.post(rootGetters['api/polygonsRestore'](id), { fingerprint }).then((res) => res.data.data)
  },
  fetchImportRestorePlan ({ rootGetters }, importId) {
    return axios.get(rootGetters['api/polygonsImportRestorePlan'](importId)).then((res) => res.data.data)
  },
  restoreImport ({ rootGetters }, { importId, fingerprints }) {
    return axios.post(rootGetters['api/polygonsImportRestore'](importId), { fingerprints }).then((res) => res.data.data)
  },
  // загрузка из Юпитера: { running: { kind, state, user, at } | null, last: { kind, ok, error, finishedAt } | null }
  fetchJupiterImport ({ rootGetters }) {
    return axios.get(rootGetters['api/polygonsJupiterImport']).then((res) => res.data.data)
  },
  startJupiterImport ({ rootGetters }, kind) {
    return axios.post(rootGetters['api/polygonsJupiterImportStart'](kind)).then((res) => res.data.data)
  },
  // журнал изменений зон: { items, meta: { page, hasMore } }
  fetchHistory ({ rootGetters }, params) {
    return axios
      .get(rootGetters['api/polygonsHistory'], { params })
      .then((res) => ({ items: res.data.items || [], meta: res.data.meta || {} }))
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
